import { Cart } from 'shopify-types'

import { GlobalRequestOptions } from '../types'
import { createCart } from './create'

export const buyNow =
  (options: GlobalRequestOptions) =>
  async (merchandiseId: string, quantity: number): Promise<Cart> =>
    createCart(options)({ lines: [{ merchandiseId, quantity }] })
